import { useState } from 'react';

import { useLocalPref } from '../../hooks/useLocalPref';
import { useManualProgressTracking } from '../../hooks/useProgressTracking';
import { useResponsive } from '../../ResponsiveProvider';
import { styles } from '../../style';
import { Button } from '../common/Button';
import { InitialFocus } from '../common/InitialFocus';
import { Input } from '../common/Input';
import { Modal } from '../common/Modal';
import { View } from '../common/View';
import { type CommonModalProps } from '../Modals';

type RenameBudgetModalProps = {
  modalProps: CommonModalProps;
};

const RenameBudgetModal = ({ modalProps }: RenameBudgetModalProps) => {
  const [budgetName, setBudgetNamePref] = useLocalPref('budgetName');
  const [budgetNewName, setBudgetNewName] = useState('');
  const { isNarrowWidth } = useResponsive();
  const { markBudgetRenamed } = useManualProgressTracking();
  const narrowButtonStyle = isNarrowWidth
    ? {
        height: styles.mobileMinHeight,
      }
    : {};

  const confirmNewBudgetName = () => {
    if (budgetNewName.trim() !== '') {
      setBudgetNamePref(budgetNewName);
      // Mark the rename-budget task as completed
      markBudgetRenamed();
    }
    modalProps.onClose();
  };

  const closeModalHandler = () => {
    setBudgetNewName('');
    modalProps.onClose();
  }

  return (
    <Modal
      title="Rename Budget File"
      showHeader
      focusAfterClose={false}
      {...modalProps}
    >
      <View style={{ gap: 16 }}>
        <InitialFocus>
          <Input
            style={{
              fontSize: 16,
              fontWeight: 500,
            }}
            defaultValue={budgetName}
            onChange={e => {
              const inputEl = e.target as HTMLInputElement;
              const newBudgetName = inputEl.value;
              setBudgetNewName(newBudgetName);
            }}
            onEnter={confirmNewBudgetName}
          />
        </InitialFocus>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            style={{
              marginRight: 10,
              ...narrowButtonStyle,
            }}
            onClick={closeModalHandler}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            style={narrowButtonStyle}
            onClick={confirmNewBudgetName}
          >
            Confirm
          </Button>
        </View>
      </View>
    </Modal>
  );
};
export default RenameBudgetModal;
